export default "__VITE_ASSET__BDgpV0Wj__"